import wtOrder from "@/views/wtOrder/index.vue";
import wallet from "@/views/wallet/index.vue";
import walletNew from "@/views/walletNew/index.vue";
import virtualAccount from "@/views/paySet/virtualAccount.vue";

const wtActivityTitleMap = {
  "0": "创建新活动",
  "1": "活动详情",
  "2": "编辑活动",
  "3": "创建新活动"
};
const baseRoutes = [
  {
    path: "/virtualAccount",
    name: "virtualAccount",
    meta: { hasMenu: true },
    component: virtualAccount
  },
  {
    path: "/import",
    name: "import",
    component: () => import("@/views/import/index.vue")
  },
  {
    path: "/test",
    name: "test",
    component: () => import("@/views/test/index.vue")
  },
  // {
  //   path: "/change",
  //   component: () => import("@/views/changePassword.vue"),
  //   children: [
  //     {
  //       path: "/changePassword",
  //       name: "changePassword",
  //       component: () => import("@/views/changePasswordForm.vue")
  //     }
  //   ]
  // },
  {
    path: "/wtActivity/:type",
    name: "wtActivityType",
    meta: { hasMenu: true },
    component: () => import("@/views/wtActivity/index.vue")
  },
  {
    path: "/wtActivity",
    name: "wtActivity",
    meta: { hasMenu: true },
    component: () => import("@/views/wtActivity/index.vue")
  },
  {
    path: "/wtActivityEdit",
    name: "WtActivityEdit",
    meta: { 
      hasMenu: true, 
      activeMenuIndex: "/wtActivity",
    },
    beforeEnter (to, from, next) {
      let {query}= to;
      let status:any = query.pageStatus || '0';
      to.meta.breadcrumbs= [
        {
          title: wtActivityTitleMap[status]
        }
      ]
      next();
    },
    component: () => import("@/views/wtActivity/wtActivityEdit.vue")
  },
  {
    path: "/wtActivity/pcr/wtActivityEdit",
    name: "WtActivityEditType",
    meta: { hasMenu: true, activeMenuIndex: "/wtActivity/pcr"},
    beforeEnter (to, from, next) {
      let {query}= to;
      let status:any = query.pageStatus || '0';
      to.meta.breadcrumbs= [
        {
          title: wtActivityTitleMap[status]
        }
      ]
      next();
    },
    component: () => import("@/views/wtActivity/wtActivityEdit.vue")
  },
  {
    path: "/wtActivity/tbr/wtActivityEdit",
    name: "WtActivityEditTypeTBR",
    meta: { hasMenu: true, activeMenuIndex: "/wtActivity/tbr" },
    beforeEnter (to, from, next) {
      let {query}= to;
      let status:any = query.pageStatus || '0';
      to.meta.breadcrumbs= [
        {
          title: wtActivityTitleMap[status]
        }
      ]
      next();
    },
    component: () => import("@/views/wtActivity/wtActivityEdit.vue")
  },
  {
    path: "/setPrice",
    name: "setPrice",
    meta: { hasMenu: true },
    component: () => import("@/views/setPrice/index.vue")
  },
  {
    path: "/product",
    name: "Product",
    meta: { hasMenu: true },
    component: () => import("@/views/product/index.vue")
  },
  {
    path: "/export",
    name: "Export",
    component: () => import("@/views/exportPage/index.vue")
  },
  {
    path: "/productEdit",
    name: "ProductEdit",
    meta: { 
      hasMenu: true, 
      activeMenuIndex: "/product",
      breadcrumbs: [
        {
          title: '编辑商品'
        }
      ]
     },
    component: () => import("@/views/product/ProductEdit.vue")
  },
  {
    path: "/productPrice",
    name: "productPrice",
    meta: { hasMenu: true },
    component: () => import("@/views/wtPrice/index.vue")
  },
  {
    path: "/wallet",
    name: "Wallet",
    meta: { hasMenu: true },
    component: wallet
  },
  {
    path: "/walletNew",
    name: "WalletNew",
    meta: { hasMenu: true },
    component: walletNew
  },
  {
    path: "/userManager",
    name: "userManager",
    meta: { hasMenu: true },
    component: () => import("@/views/setting/userManager/index.vue")
  },
  {
    path: "/roleManager",
    name: "roleManager",
    meta: { hasMenu: true },
    component: () => import("@/views/setting/roleManager/index.vue")
  },
  {
    path: "/tagManager",
    name: "tagManager",
    meta: { hasMenu: true },
    component: () => import("@/views/setting/tagManager/index.vue")
  },
  {
    path: "/couponpcr", // 优惠券明细
    name: "couponpcr",
    meta: { hasMenu: true },
    component: () => import("@/views/owner/couponPCR.vue")
  },
  {
    path: "/couponDetailPCR",
    name: "couponDetailPCR", // 优惠券明细PCR
    meta: {
      activeMenuIndex: "/couponpcr"
    },
    beforeEnter (to, from, next) {
      let {query}= to;
      let code:any = query.code || '-';
      to.meta.breadcrumbs= [
        {
          title: '优惠券编码 ' + code
        }
      ]
      next();
    },
    component: () => import("@/views/owner/detail.vue")
  },
  {
    path: "/storeMg",
    name: "storeMg", // 门店管理
    meta: {
      hasMenu: true
    },
    component: () => import("@/views/storeManageIndex/index.vue")
  },
  {
    path: "/storeMgDetail",
    name: "storeMgDetail", // 门店管理详情
    meta: {
      activeMenuIndex: "/storeMg",
      breadcrumbs: [
        {
          title: '门店详情'
        }
      ]
    },
    component: () => import("@/views/storeManage/StoreDetail.vue")
  },
  {
    path: "/warrantyCheck",
    name: "warrantyCheck", // 质保售后审核
    meta: {
      hasMenu: true
    },
    component: () => import("@/views/warrantyCheck/index.vue")
  },
  {
    path: "/warrantyDetailPCR",
    name: "warrantyDetailPCR", // 质保卡明细
    meta: {
      breadcrumbs: [
        {
          title: "质保卡明细"
        }
      ]
      // activeMenuIndex: "/warrantyDetailPCR"
    },
    component: () => import("@/views/warrantyDetail/index.vue")
  },
  {
    path: "/wtOrder",
    name: "wtOrder",
    meta: { hasMenu: true },
    component: wtOrder
  },
  {
    path: "/k2ExceptionRecord",
    name: "k2ExceptionRecord",
    meta: { hasMenu: true },
    component: () => import("@/views/wtK2ScanCodeException/index.vue")
  },
  // {
  //   path: "/changePwd",
  //   name: "changePasswordForm",
  //   component: () => import("@/views/changePasswordForm.vue")
  // },
  // {
  //   path: "/changePwd/success",
  //   name: "changePasswordSuccess",
  //   meta: { hasMenu: true },
  //   component: () => import("@/views/changePasswordSuccess.vue")
  // },
  {
    path: "/clientLevel",
    name: "clientLevel",
    meta: { hasMenu: true },
    component: () => import("@/views/clientLevel/index.vue")
  },
  {
    path: "/ssp",
    name: "StoreAnswer",
    component: () => import("@/views/other/storeAnswer.vue")
  },
  {
    path: "/warehousingCheck/record",
    name: "warehousingCheckRecord",
    meta: {
      breadcrumbs: [
        {
          title: '入库核单记录'
        }
      ]
    },
    component: () => import("@/views/warehousingCheck/record.vue")
  },


  {
    path: "/creditAccounting",
    name: "creditAccounting", // 信用金记账明细
    meta: {
      hasMenu: true
    },
    component: () => import("@/views/credit/index.vue")
  },


  {
    path: "/rewardAccounting",
    name: "rewardAccounting", // K2奖励金记账明细
    meta: {
      hasMenu: true
    },
    component: () => import("@/views/rewardAccounting/index.vue")
  },

  {
    path: "/kaReward",
    name: "reward", // 奖励金
    meta: {
      hasMenu: true
    },
    component: () => import("@/views/kaReward/index.vue")
  },

  {
    path: "/k2coupon",
    name: "k2coupon", // K2优惠券管理
    meta: {
      hasMenu: true
    },
    component: () => import("@/views/k2coupon/k2CouponLayout.vue")
  }
];

// 库存查询
// 库存流水
// 异常记录
// k2入库记录
// k2出库记录
const fileRoutes = [
  "inventoryQuery",
  "inventoryFlow",
  "k1ExceptionRecord",
  "k2Entry",
  "k2Outbound"
];

const normalRoutes = fileRoutes.map(file => {
  return {
    path: `/${file}`,
    name: `${file}`,
    meta: { hasMenu: true },
    component: () => import(`@/views/scan/${file}/index.vue`)
  };
});

const addRouters = [
  {
    path: `/inventoryFlow/detail`,
    name: "flowDetail",
    meta: { hasMenu: true, activeMenuIndex: "/inventoryFlow",},
    beforeEnter (to, from, next) {
      let {query}= to;
      let code:any = query.code || '-';
      to.meta.breadcrumbs= [
        {
          title: '流水号 ' + code
        }
      ]
      next();
    },
    component: () => import(`@/views/scan/inventoryFlow/detail.vue`)
  }
];

const scanRoutes = [...normalRoutes, ...addRouters];

// TODO BY JIABO.ZHANG
// 暂时不知道为什么路由这样被分组 按照原作者意图该的

export default [...baseRoutes, ...scanRoutes];
